<template>
    <div class="card quota-info-card shadow-sm mb-3">
        <!-- Modern Header Action Bar -->
        <div class="card-header quota-info-card-header py-3 px-3 px-md-4 d-flex align-items-center justify-content-between flex-wrap gap-2"
             v-if="!editing && !insert">
            <div class="d-flex align-items-center gap-2">
                <span class="quota-icon-box">
                    <i class="bi bi-file-earmark-text"></i>
                </span>
                <div>
                    <div class="d-flex align-items-center gap-2">
                        <h6 class="mb-0 fw-bold quota-main-num">{{ data.quotaFullNumber }}</h6>
                        <span class="status-badge-pill badge--approved">
                            <i class="bi bi-check-circle-fill me-1"></i> Yeni
                        </span>
                    </div>
                    <small class="text-muted" style="font-size: 0.78rem;">Təklif məlumatları və şərtlər</small>
                </div>
            </div>
            <div class="d-flex align-items-center flex-wrap gap-2">
                <button type="button" v-if="!send" class="btn action-btn action-btn--info"
                    @click="ToggleEdit(); editing = true;">
                    <i class="bi bi-pencil-square me-1"></i>
                    <span>Düzəliş</span>
                </button>
                <button type="button" v-if="$route.path.split('/')[3] == '2'" class="btn action-btn action-btn--success"
                    @click="approveDialog = true">
                    <i class="bi bi-check2-circle me-1"></i>
                    <span>Təsdiq</span>
                </button>
                <button type="button" v-if="$route.path.split('/')[3] == '2'" class="btn action-btn action-btn--danger"
                    @click="Delete()">
                    <i class="bi bi-x-circle me-1"></i>
                    <span>İmtina</span>
                </button>
                <button type="button" v-if="!send && $route.path.split('/')[3] != '2'" class="btn action-btn action-btn--success"
                    @click="send = true">
                    <i class="bi bi-send-check me-1"></i>
                    <span>Təsdiqə göndər</span>
                </button> 
                <button type="button" class="btn action-btn action-btn--muted" @click="GetData()">
                    <i class="bi bi-arrow-clockwise me-1"></i>
                    <span>Yeniləmək</span>
                </button>
            </div>
        </div>

        <!-- Card Body -->
        <div class="card-body p-3 p-md-4" v-loading="loading">
            <Data :data="data" v-if="!editing && !insert" :statusData="statusData"></Data>
            <Edit @close-dialog="editing = false; insert = false;" @insert-dialog="ToggleEdit();"
                :editing="editing" v-if="editing || insert" :insert="insert"></Edit> 
        </div>
    </div>

    <!-- Approve Dialog -->
    <el-dialog v-model="approveDialog" width="420px" title="Yeni müqavilə"
        modal-class="modal-class" :close-on-click-modal="false" :destroy-on-close="true">
        <el-form-item label="Müqavilə başlanma tarixi" label-position="top">
            <el-date-picker format="DD.MM.YYYY" v-model="startDate" class="w-100" type="date"
                placeholder="Tarixi seçin" />
        </el-form-item>
        <template #footer>
            <div class="d-flex justify-content-end gap-2 pt-2 border-top">
                <button type="button" class="btn action-btn action-btn--muted" @click="approveDialog = false">
                    İmtina
                </button>
                <button type="button" class="btn action-btn action-btn--success" @click="Approve">
                    <i class="bi bi-check-lg me-1"></i>
                    <span>Daxil et</span>
                </button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import Edit from "./Components/Edit.vue";
import Data from "./Components/Data.vue";

export default {
    name: "QuotaInfoMain",
    components: {
        Data,
        Edit
    },
    data() {
        return {
            send: false,
            startDate: null,
            approveDialog: false,
            data: {
                quotaId: "QT-2025-001",
                quotaDateStr: "16.08.2025",
                quotaFullNumber: "Q-2025-007",
                generalDate: "01.08.2025",
                generalFullNumber: "GM-45678/2025",
                period: 36,
                currency: "AZN",
                payType: "Aylıq",
                // məsul şəxslər
                agentName: "Vəfa Əbilova",
                underwritingName: "Elvin Rzayev",
                curatorName: "Samir Qasımov",

                // sığortalı (şirkət)
                insured: {
                    name: "Xəzər Holdinq MMC",
                    address: "Bakı, Nərimanov r., Heydər Əliyev pr. 125",
                    phone: "+994 12 555 66 77",
                    clientSector: "Neft sektoru",
                    voen: "878455554865"
                },

                // faydalanan (fiziki şəxs)
                beneficiary: {
                    name: "Leyla Quliyeva",
                    address: "Bakı, Yasamal r., Şərifzadə küç. 45"
                }
            },
            statusData: [
                {
                    statusId: 0,
                    status: "Yeni",
                    user: "Rufiz Məmmədov",
                    time: "16.08.2025 14:22"
                },
                {
                    statusId: 4,
                    status: "Göndərildi təsdiqə",
                    user: "Aygün Quliyeva",
                    time: "16.08.2025 14:45"
                },
                {
                    statusId: 2,
                    status: "Təsdiqləndi",
                    user: "Admin",
                    time: "16.08.2025 15:05"
                }
            ],
            loading: false,
            editing: false,
            insert: false
        };
    },
    methods: {
        ToggleEdit() {
            this.$emit('insert');
        },
        Approve() {
            window.location.href = window.location.origin + '/documents/policy/3';
        },
        GetData() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        async Delete() {
            // Delete handler
        }
    },
    mounted() {
        if (this.$route.path.split("/")[3] === "new") {
            this.insert = true;
        }
    }
};
</script>

<style scoped lang="scss">
.quota-info-card {
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 8px);
    background: var(--app-surface, #ffffff);
}

.quota-icon-box {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: rgba(11, 79, 156, 0.1);
    color: var(--bs-info, #0b4f9c);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
}

.quota-main-num {
    font-size: 1rem;
    color: var(--app-heading, #1e293b);
}

.status-badge-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 700;

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.35);
    }
}

[data-theme="dark"] {
    .quota-info-card {
        background: #182029;
        border-color: #2e3846;
    }

    .quota-icon-box {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    .quota-main-num {
        color: #f1f5f9;
    }

    .status-badge-pill.badge--approved {
        background: rgba(16, 185, 129, 0.18);
        color: #34d399;
        border-color: rgba(52, 211, 153, 0.35);
    }
}
</style>